import { Component, OnDestroy, Input, TemplateRef, ContentChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';



@Component({
    selector: 'btn-cell-renderer-comments',
    template: `
	<em class="table_edit">
	<img style="padding-right:16px;color-red" src="./assets/images/comment-dots-regular.svg" 
	(click)="btnClickedHandler($event)" style="cursor:pointer;"> 
	</em>
	`,
    standalone: false
})
export class BtnCellRendererComments implements ICellRendererAngularComp, OnDestroy {



	refresh(params: ICellRendererParams): boolean {
		throw new Error(`Error while refreshing renderer component. INFO-${params}`);
	}

	private params: any;
	pageName;
	enableEdit: boolean = true; 

	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field;
	}

	btnClickedHandler(_event) {
		
		if (this.pageName == 'route_comments') {  // NOSONAR
			this.params.context.componentParent.routeComments(this.params.data, this.pageName);
		}

	}

	ngOnDestroy() {
console.info()


	}
}
